import React from 'react';
import PropTypes from 'prop-types';

import styles from './PromoPrice.scss';
import {__t} from "../lang/text-resource";

const PromoPrice = ({
						oldPrice,
						newPrice,
						withMonth,
						currency,
						hideStar,
						newPriceFree,
						newPriceFirst,
						newPriceClass,
						oldPriceClass,
						currencyClass
					}) => {

	const currencyMap = {
		BGN: __t('лв'),
		EUR: __t('евро')
	};

	if (typeof (oldPrice) === 'string') {
		oldPrice = oldPrice.replace('.', ',');
	}
	if (typeof (newPrice) === 'string') {
		newPrice = newPrice.replace('.', ',');
	}

	let oldPriceFMT = '';
	let newPriceFMT = '';
	let termSeparator = '/';

	if (currency === 'BGN') {
		oldPriceFMT =
		  <span>
				<span>{oldPrice}</span> <span className={currencyClass}>{currencyMap[currency]}</span>
			</span>;
		newPriceFMT =
		  <span>
				<span>{newPrice}</span> {newPriceFree !== true &&
			<span className={currencyClass}>{currencyMap[currency]}{hideStar !== true ? '*' : ''}</span>}
			</span>;
	} else {

		oldPriceFMT =
		  <span>
			  <span>{oldPrice}</span>
				<span className={currencyClass}>{currencyMap[currency]}</span>
			</span>;
		newPriceFMT =
		  <span>
			  <span>{newPrice}</span>
			  &nbsp;
			  {newPriceFree !== true &&
				<span className={currencyClass}>{currencyMap[currency]}{hideStar !== true ? '*' : ''}</span>}
			</span>;

	}
	if (newPriceFirst) {
		return (
		  <div className={styles.priceContainer}>

			  {
				  (withMonth) ?
					<div className={`${styles.newPrice} ${newPriceClass}`}>
						{newPriceFMT}{termSeparator}{__t('мес')}
					</div>
					:
					<div className={`${styles.newPrice} ${newPriceClass}`}>
						{newPriceFMT}
					</div>
			  }
			  {
				  (oldPrice > 0 && newPrice !== oldPrice) ?
					(withMonth) ?
					  <div className={`${styles.oldPrice} ${oldPriceClass}`}>
						  {oldPriceFMT}{termSeparator}{__t('мес')}
					  </div>
					  :
					  <div className={`${styles.oldPrice} ${oldPriceClass}`}>
						  {oldPriceFMT}
					  </div>
					:
					null
			  }
		  </div>
		);
	}
	return (
	  <div className={styles.priceContainer}>
		  {
			  (oldPrice > 0 && newPrice !== oldPrice) ?
				(withMonth) ?
				  <div className={`${styles.oldPrice} ${oldPriceClass}`}>
					  {oldPriceFMT}{termSeparator}{__t('мес')}
				  </div>
				  :
				  <div className={`${styles.oldPrice} ${oldPriceClass}`}>
					  {oldPriceFMT}
				  </div>
				:
				null
		  }
		  {
			  (withMonth) ?
				<div className={`${styles.newPrice} ${newPriceClass}`}>
					{newPriceFMT}{termSeparator}{__t('мес')}
				</div>
				:
				<div className={`${styles.newPrice} ${newPriceClass}`}>
					{newPriceFMT}
				</div>
		  }
	  </div>
	);
};
PromoPrice.defaultProps = {
	withMonth: true,
	newPriceFirst: false,
	oldPrice: null,
	newPriceClass: '',
	oldPriceClass: '',
	currencyClass: '',
};

//
PromoPrice.propTypes = {
	newPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	oldPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	withMonth: PropTypes.bool,
	newPriceFree: PropTypes.bool,
	hideStar: PropTypes.bool,
	newPriceFirst: PropTypes.bool,
	currency: PropTypes.string,
	newPriceClass: PropTypes.string,
	oldPriceClass: PropTypes.string,
	currencyClass: PropTypes.string
};

export default PromoPrice;
